<template>
  <div class="scenicList">
    <ul class="list">
      <li v-for="item in list" :key="item.id">
		<image class="pic" lazy-load :src="item.imageUrl" mode="aspectFill"  />
        <div class="txt">
          <p class="title">{{ item.name }}</p>
          <div class="labels">
            <span v-for="(item, index) in item.label" :key="index">
              {{ item }}
            </span>
          </div>
          <p class="foot">
            <span class="lf">
              <span class="symbol">
                ￥
              </span>
              <span class="money" v-html="item.referPrice"></span>
              <span class="up">起</span>
            </span>
            <span class="sell">
              已有1234人出游
            </span>
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { covertMoney } from "@/common/js/util.js";
export default {
  name: "vanScenic",
  data() {
    return {
    };
  },
  props: {
      dataList: {
        type: Array,
        default () {
          return []
        }
      }
    },
	computed: {
	    list () {
	      return this.dataList.map(res => {
	        let { referPrice, ...lst } = res
	        return {
	          ...lst,
	          referPrice: covertMoney(referPrice)
	        }
	      })
	    }
	  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.scenicList {
  overflow: hidden;
  .list {
    margin: 5px 15px;
    // overflow: hidden;
    width: 345px;
    padding-bottom: 6px;
    li {
      display: flex;
      border-radius: 4px;
      margin-bottom: 10px;
      overflow: hidden;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.12);
      .pic {
        width: 140px;
        height: 115px;
        background-size: cover;
        background-position: center center;
        position: relative;
      }
      .txt {
        width: 195px;
        margin-left: 10px;
        padding-right: 10px;
        .title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #333;
          font-size: 15px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          line-height: 28px;
          margin-top: 6px;
        }
        .labels {
          overflow: hidden;
          height: 40px;
          margin-bottom: 12px;
          span {
            border: #ff740b 1px solid;
            color: #ff740b;
            padding: 1px 4px;
            border-radius: 2px;
            font-size: 11px;
            font-weight: 400;
            float: left;
            line-height: 12px;
            margin: 0 4px 4px 0;
          }
        }
        .foot {
          display: flex;
          line-height: 26px;
          justify-content: space-between;
          // margin-top:4px;
          .lf {
            display: flex;
          }
          .symbol {
            font-size: 11px;
            color: #ff5041;
            font-family: PingFangSC-Semibold, PingFang SC;
            // margin:3px 0 0 0;
            // font-weight:600;
          }
          .money {
            font-size: 20px;
            font-weight: bold;
            color: #ff3e2d;
            font-family: HelveticaNeue-Bold, HelveticaNeue;
            margin: -2px 3px 0 0;
            /deep/.number {
              font-size: 11px !important;
            }
          }
          .up {
            font-size: 11px;
            color: #999;
            margin-top: 3px;
          }
          .sell {
            color: #999;
            font-size: 11px;
			margin-top:3px;
          }
        }
      }
    }
  }
  .more {
    border: #ff740b 1px solid;
    color: #ff740b;
    border-radius: 2px;
    width: 70px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    font-size: 12px;
    margin: 0 auto 10px auto;
    clear: both;
  }
}
</style>
